import gql from "graphql-tag";

/**
 * Stubs for admin "import" operations referenced by hooks/use-import.ts and
 * form/_SelectAct.tsx. These were not present in the legacy GraphQL barrel
 * either (a pre-existing dangling reference). Defined here so imports resolve;
 * they target features the new backend does not yet expose.
 */
export const queryGetActSelect = gql`
  query GetActSelect {
    __typename
  }
`;
export const mutationImportOrganisation = gql`
  mutation ImportOrganisation {
    __typename
  }
`;
export const mutationImportAct = gql`
  mutation ImportAct {
    __typename
  }
`;
export const mutationImportVenue = gql`
  mutation ImportVenue {
    __typename
  }
`;
export const mutationImportEvent = gql`
  mutation ImportEvent {
    __typename
  }
`;
